import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class HelpFileSource extends AbstractSource implements IContentSource {
  constructor(
    getToken: () => string,
    public fileId: number,
  ) {
    super(getToken);
  }

  protected getSource(): string {
    return "/api/help/file/" + this.fileId + "?token=" + this.token;
  }

  public clone(): IContentSource {
    return new HelpFileSource(
      this._getToken,
      this.fileId
    );
  }
}
